module.exports = __webpack_public_path__ + "school/img/xiaoxueJc.3fe53d36.jpg";